import { defineMessage } from 'react-intl'

import iconBus from 'assets/icons/bus.svg'
import iconGrill from 'assets/icons/grill.svg'
import iconPlayground from 'assets/icons/playground.svg'
import iconShops from 'assets/icons/shops.svg'
import iconSlide from 'assets/icons/slide.svg'
import iconBicycle from 'assets/icons/bicycle.svg'
import iconAnimal from 'assets/icons/animal.svg'
import iconKid from 'assets/icons/kid.svg'

import grandVillaOverview from 'assets/images/accommodation/modal/grandVilla.jpg'
import familyBungalowOverview from 'assets/images/accommodation/modal/familyBungalow.jpg'
import juniorBungalowOverview from 'assets/images/accommodation/modal/juniorBungalow.jpg'

export const amenitiesData = [
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_shop',
            defaultMessage: '_',
        }),
        icon: iconShops,
        iconAlt: 'shops icon',
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_water_park',
            defaultMessage: '_',
        }),
        additionalText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_paid_additionally',
            defaultMessage: '_',
        }),
        icon: iconSlide,
        iconAlt: 'slide icon',
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_bus',
            defaultMessage: '_',
        }),
        icon: iconBus,
        iconAlt: 'bus icon',
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_bicycles',
            defaultMessage: '_',
        }),
        icon: iconBicycle,
        iconAlt: 'bicycle icon',
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_barbecue_zone',
            defaultMessage: '_',
        }),
        icon: iconGrill,
        iconAlt: 'grill icon',
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_animal_friendly',
            defaultMessage: '_',
        }),
        icon: iconAnimal,
        iconAlt: 'animal icon',
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_playground',
            defaultMessage: 'Plac zabaw',
        }),
        icon: iconPlayground,
        iconAlt: 'playground icon',
    },
    {
        highlightedText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_kids_3y_for_free',
            defaultMessage: '_',
        }),
        additionalText: defineMessage({
            id: 'accommodation.bungalow_modal.amenities_kids_3y_bed_on_demand',
            defaultMessage: '_',
        }),
        icon: iconKid,
        iconAlt: 'slide icon',
    },
]

const equipmentData = {
    kitchen: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_kitchenette',
            defaultMessage: '_',
        }),
    },
    hairdryer: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_hairdryer',
            defaultMessage: '_',
        }),
    },
    double_bed: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_double_bed',
            defaultMessage: '-',
        }),
    },
    air_conditioning: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_air_conditioning',
            defaultMessage: '_',
        }),
    },
    single_bed: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_single_bed',
            defaultMessage: '_',
        }),
    },
    single_or_double_bed: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_single_or_double_bed',
            defaultMessage: '_',
        }),
    },
    smart_tv: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_smart_tv',
            defaultMessage: '_',
        }),
    },
    smart_tv_x2: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_smart_tv_x2',
            defaultMessage: '_',
        }),
    },
    sofa: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_sofa',
            defaultMessage: '_',
        }),
    },
    slippers: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_slippers',
            defaultMessage: '_',
        }),
    },
    deposit_box: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_safe',
            defaultMessage: '_',
        }),
    },
    ironing_set: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_ironing_set',
            defaultMessage: '_',
        }),
        isOnDemand: true,
    },
    wifi: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_wifi',
            defaultMessage: '_',
        }),
    },
    bathrobe: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_bathrobe',
            defaultMessage: '_',
        }),
        isOnDemand: true,
    },
    baby_bed: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_baby_bed',
            defaultMessage: '_',
        }),
        isOnDemand: true,
    },
    terrace: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_terrace',
            defaultMessage: '_',
        }),
    },
    bathtub: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_bathtub',
            defaultMessage: '_',
        }),
    },
    coffee_machine: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_coffee_machine',
            defaultMessage: '_',
        }),
    },
    fireplace: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_fireplace',
            defaultMessage: '_',
        }),
    },
    wine: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_wine',
            defaultMessage: '_',
        }),
    },
    private_terrace: {
        name: defineMessage({
            id: 'accommodation.bungalow_modal.equipment_private_terrace',
            defaultMessage: '_',
        }),
    },
}

const grandVillaInfo = {
    id: 'grand-villa',
    name: defineMessage({
        id: 'accommodation.bungalow_modal.grand_villa_name',
        defaultMessage: '_',
    }),
    description: defineMessage({
        id: 'accommodation.bungalow_modal.grand_villa_teaser',
        defaultMessage: '_',
    }),
    image: grandVillaOverview,
    maxGuests: 8,
    equipment: [
        equipmentData.kitchen,
        equipmentData.double_bed,
        equipmentData.single_bed,
        equipmentData.sofa,
        equipmentData.deposit_box,
        equipmentData.wifi,
        equipmentData.baby_bed,
        equipmentData.hairdryer,
        equipmentData.air_conditioning,
        equipmentData.smart_tv_x2,
        equipmentData.slippers,
        equipmentData.ironing_set,
        equipmentData.bathrobe,
    ],
    equipmentPremium: [
        equipmentData.bathtub,
        equipmentData.fireplace,
        equipmentData.private_terrace,
        equipmentData.coffee_machine,
        equipmentData.wine,
    ],
    isNew: true,
    isPremium: true,
}

const familyBungalowInfo = {
    id: 'family-bungalow',
    name: defineMessage({
        id: 'accommodation.bungalow_modal.family_bungalow_name',
        defaultMessage: '_',
    }),
    description: defineMessage({
        id: 'accommodation.bungalow_modal.family_bungalow_teaser',
        defaultMessage: '_',
    }),
    image: familyBungalowOverview,
    maxGuests: 4,
    equipment: [
        equipmentData.kitchen,
        equipmentData.single_or_double_bed,
        equipmentData.sofa,
        equipmentData.wifi,
        equipmentData.deposit_box,
        equipmentData.baby_bed,
        equipmentData.hairdryer,
        equipmentData.air_conditioning,
        equipmentData.smart_tv,
        equipmentData.terrace,
        equipmentData.ironing_set,
    ],
    equipmentPremium: [],
    isNew: false,
    isPremium: false,
}

const juniorBungalowInfo = {
    id: 'junior-bungalow',
    name: defineMessage({
        id: 'accommodation.bungalow_modal.junior_bungalow_name',
        defaultMessage: '_',
    }),
    description: defineMessage({
        id: 'accommodation.bungalow_modal.junior_bungalow_teaser',
        defaultMessage: '_',
    }),
    image: juniorBungalowOverview,
    maxGuests: 2,
    equipment: [
        equipmentData.kitchen,
        equipmentData.single_or_double_bed,
        equipmentData.wifi,
        equipmentData.deposit_box,
        equipmentData.baby_bed,
        equipmentData.hairdryer,
        equipmentData.air_conditioning,
        equipmentData.smart_tv,
        equipmentData.terrace,
        equipmentData.ironing_set,
    ],
    equipmentPremium: [],
    isNew: true,
    isPremium: false,
}

export const bungalowsData = [
    grandVillaInfo,
    familyBungalowInfo,
    juniorBungalowInfo,
]
